export default __webpack_public_path__ + "static/sz_hu_6-e91aa021211c277e5c033959817d641a.mp4";